import Button from "@/components/button/Button"
import WebsiteTypography from "@/components/websiteTypography/WebsiteTypography"
import { useBreakpoint } from "@/hooks/useBreakpoint"
import { getPageNameFromPathname } from "@/pages/website-landing/helpers/getPageNameFromPathname"
import ApplyItem from "@/pages/website-landing/home/sections/how-to-apply/apply-item/ApplyItem"
import { ApplyItemType } from "@/pages/website-landing/home/sections/how-to-apply/HowToApply"

import { useModalDarkContext } from "@/components/context/ModalDarkContext"
import WebsiteButton from "@/components/website-button/WebsiteButton"
import { websiteRoutes } from "@/router/routes"
import { EASETECH } from "@/utilities/global-variables"
import { Col, Row } from "antd"
import { FC } from "react"
import { useLocation, useParams } from "react-router"
import { useNavigate } from "react-router-dom"
import supportImg from "./assets/Headphone.png"
import iconImage02 from "./assets/quick-submission.png"
import iconImage03 from "./assets/Simplification.png"
import iconImage04 from "./assets/Sircling.png"
import iconImage01 from "./assets/smart-home.png"
import "./OrgHowItWorks.less"

const { Title, Paragraph } = WebsiteTypography

type OrgHowItWorksContent = {
  title?: string
  subtitle?: string
  hexItem?: string[]
  bannerText?: string
}

type Props = {
  content: OrgHowItWorksContent
}

const OrgHowItWorks: FC<Props> = ({ content }) => {
  const params = useParams()
  const navigate = useNavigate()
  const currentOrgSlug = params.org || EASETECH
  const { website } = websiteRoutes
  const { pathname } = useLocation()

  const { openDarkModal } = useModalDarkContext()

  const { portal } = getPageNameFromPathname(pathname)

  const howWorksItems: ApplyItemType[] = [
    {
      id: "1",
      description: content?.hexItem?.[0] ?? "",
      imageUrl: iconImage01,
    },
    {
      id: "2",
      description: content?.hexItem?.[1] ?? "",
      imageUrl: iconImage02,
    },
    {
      id: "3",
      description: content?.hexItem?.[2] ?? "",
      imageUrl: iconImage03,
    },
    {
      id: "4",
      description: content?.hexItem?.[3] ?? "",
      imageUrl: iconImage04,
    },
  ]

  const onRegisterClick = () => {
    navigate(`/${currentOrgSlug}${website.auth}/${portal}/client`, {
      state: { from: location.pathname },
    })
  }

  const handleContactRequestClick = () => {
    openDarkModal({
      type: "quick-contact",
      isLogo: true,
    })
  }

  return (
    <div className={"org-how-works"}>
      <div className={"container"}>
        <div className={"org-how-works-wrapper"}>
          {/* An h2: the hero above it (OrgLanding, OrgAoiHeroSection) is the page's h1 */}
          <Title level={2} sizeAs={1} centered style={{ paddingBottom: 16 }}>
            <span className={"bold"}>{content.title}</span>
          </Title>

          <Paragraph size={"lg"} color={"website-secondary"} centered>
            {content.subtitle}
          </Paragraph>

          <div className={"cards-content-wrapper"}>
            <div className={"cards-container"}>{howWorksItems?.map(it => <ApplyItem it={it} key={it?.id} />)}</div>
          </div>

          <Row justify={"center"} style={{ width: "100%" }}>
            <Col xxl={20} xl={20} lg={20} md={18} sm={16} xs={22}>
              <Row justify={"center"} style={{ paddingBottom: 40 }}>
                <Col span={24}>
                  <Row justify={"center"} style={{ width: "100%" }}>
                    <div className={"support-btn-wrapper"}>
                      <Button btnType={"text"} className={"support-btn"} onClick={handleContactRequestClick}>
                        <div className={"hexagon-wrapper"}>
                          <div className={"icon-wrapper"}>
                            <img src={supportImg} alt={"image of support service"} />
                          </div>
                        </div>
                        <Paragraph color={"website-secondary"}>{content.bannerText}</Paragraph>
                      </Button>
                    </div>
                  </Row>
                </Col>
              </Row>

              <Row justify={"center"}>
                <Col xxl={5} xl={5} lg={5} md={6} sm={12} xs={24}>
                  <WebsiteButton btnType={"primary"} onClick={onRegisterClick} size={"large"} block>
                    {"REGISTER"}
                  </WebsiteButton>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  )
}

export default OrgHowItWorks
